import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Radio, ArrowRight } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";

export default function Join() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [code, setCode] = useState(params.get("code") || "");
  const [nik, setNik] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/live/join", { code, nik });
      localStorage.setItem("live_token", data.token);
      nav(`/play/${data.token}`, { replace: true });
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col items-center justify-center p-6" data-testid="join-page">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-400 text-slate-950 grid place-items-center"><Radio className="h-7 w-7" /></div>
          <h1 className="font-heading text-3xl font-bold">Quiz Live</h1>
          <p className="text-slate-400 text-sm">Masukkan kode dari layar guru dan NIK Anda</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="join-code-input" inputMode="numeric" pattern="[0-9]*" maxLength={6} placeholder="KODE 6 DIGIT" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required
            className="w-full h-16 rounded-xl bg-slate-900 border border-slate-700 text-center font-mono text-3xl tracking-[0.4em] focus:outline-none focus:ring-2 focus:ring-amber-400" />
          <input data-testid="join-nik-input" placeholder="NIK" value={nik} onChange={(e) => setNik(e.target.value)} required
            className="w-full h-14 rounded-xl bg-slate-900 border border-slate-700 text-center font-mono text-lg focus:outline-none focus:ring-2 focus:ring-amber-400" />
          {err && <p data-testid="join-error" className="text-sm text-red-400 text-center">{err}</p>}
          <Button data-testid="join-submit-button" type="submit" disabled={busy || code.length !== 6 || !nik} className="w-full h-14 text-lg bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold rounded-xl">Masuk <ArrowRight className="h-5 w-5 ml-1" /></Button>
        </form>
        <p className="text-center text-xs text-slate-500">Nilai otomatis tersimpan ke sistem penilaian sekolah.</p>
      </div>
    </div>
  );
}
